import { inject } from "@angular/core";
import { AuthService } from "./auth.service";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import { AppRoutes } from "../app/app.routes";
import { SnackBarService } from '../shared/snack-bar/application/snack-bar.service';
import { firstValueFrom } from 'rxjs';

export const isAuthorizedGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService: AuthService = inject(AuthService);
  const router = inject(Router);
  const snackBarService = inject(SnackBarService);
  const redirectUrl: UrlTree = router.createUrlTree([`/${ AppRoutes.login }`], {
    relativeTo: null,
    queryParams: { returnUrl: state.url }
  });

  const res = await firstValueFrom(authService.me());
  if (res.isFailure()) {
    snackBarService.showError(res.failure);
    return redirectUrl;
  }

  return true;
}

export const isNotAuthorizedGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  return await firstValueFrom(authService.isLoggedIn()) ? router.createUrlTree([AppRoutes.home], { relativeTo: null }) : true;
}
